document.addEventListener('turbolinks:load', function () {
    if ($('.projects.new, .projects.create, .projects.edit, .projects.update').length === 0) {
        return false
    }

    // do not want to trigger this js if we are working on permit applications form
    // even though it is permit applications form, it is served under projects/edit so this js gets triggered
    if($('.permit_applications-form-section').length !== 0) {
        return false
    }

    window.selectedProjectType = [];

    if ($('.projects.edit, .projects.update').length !== 0) {
        processSelectionChanges();
    }

    $(document).on('change', "#v-service-requested input[type='checkbox']", function () {
        resetChanges();
        processSelectionChanges();
    })

    // fetch inspection categories when client changes
    $(document).on('change', '#project_organization_id', function () {
        var orgId = $(this).val();
        if (!orgId) {
            $('#inspection-categories-content').html('<p class="text-muted">Please select a client in the Project Overview step first.</p>');
            return;
        }
        var projectUuid = $('#project-form').data('projectUuid');
        $.get('/projects/inspection_categories_for_org', { organization_id: orgId, project_uuid: projectUuid }, function (html) {
            $('#inspection-categories-content').html(html);
        });
    });

    function processSelectionChanges() {
        var selected = [];
        if (isBothSelected()) {
            selected.push("plan_review", "inspection");
        } else if (isPlanReviewSelected()) {
            selected.push("plan_review")
        } else if (isInspectionSelected()) {
            selected.push("inspection")
        } else {
            selected = []
        }
        processSelection(selected);
        toggleNextStepButton();
    }

    function processSelection(selected) {
        if (isSameArray(selected, ["plan_review", "inspection"])) {
            selectBothService()
        } else if (selected.length === 1 && selected[0] === "plan_review") {
            selectPlanReviewOnly();
        } else if (selected.length === 1 && selected[0] === "inspection") {
            selectInspectionOnly()
        } else {
            deSelectBothService();
        }
    }

    function isSameArray(array1, array2) {
        return (array1.length === array2.length) && array1.every(function (element, index) {
            return element === array2[index];
        })
    }

    function selectBothService() {
        selectService("plan_review");
        selectService("inspection");
        showPlanReviewTabs();
        showInspectionCategoryTab();
        $("#permitInfoToInspectionCategoryBtn").removeClass("d-none");
        $("#v-permit-information .create-project-btn").addClass("d-none");
        $("#projectDetailsToPermitInfoBtn").removeClass("d-none");
        $("#projectDetailsToInspectionCategoryBtn").addClass("d-none");
        $("#inspectionCategoryPrevBtn").attr("data-target", "#v-permit-information-tab");
    }

    function selectPlanReviewOnly() {
        selectService("plan_review");
        showPlanReviewTabs();
        $("#permitInfoToInspectionCategoryBtn").addClass("d-none");
        $("#v-permit-information .create-project-btn").removeClass("d-none");
        $("#projectDetailsToPermitInfoBtn").removeClass("d-none");
        $("#projectDetailsToInspectionCategoryBtn").addClass("d-none");
    }

    function selectInspectionOnly() {
        selectService("inspection");
        $("#v-project-overview-tab").removeClass("d-none");
        $("#v-project-details-tab").removeClass("d-none");
        showInspectionCategoryTab();
        $("#projectDetailsToPermitInfoBtn").addClass("d-none");
        $("#projectDetailsToInspectionCategoryBtn").removeClass("d-none");
        $("#inspectionCategoryPrevBtn").attr("data-target", "#v-project-details-tab");

        let planReviewOnlyQuestion = $('#projectDetailsTab .plan-review-only-question');
        $(planReviewOnlyQuestion).addClass('d-none');
        $(planReviewOnlyQuestion).find('.requiredField').removeClass('requiredField').addClass('optionalField');
    }

    function deSelectBothService() {
        deSelectService("plan_review");
        deSelectService("inspection");
        $("#v-project-overview-tab, #v-project-details-tab, #v-permit-information-tab").addClass("d-none");
        hideInspectionCategoryTab();
        $("#permitInfoToInspectionCategoryBtn").addClass("d-none");
        $("#v-permit-information .create-project-btn").removeClass("d-none");
        $("#projectDetailsToPermitInfoBtn").removeClass("d-none");
        $("#projectDetailsToInspectionCategoryBtn").addClass("d-none");
    }

    function showPlanReviewTabs() {
        $("#v-project-overview-tab, #v-project-details-tab, #v-permit-information-tab").removeClass("d-none");

        let planReviewOnlyQuestion = $('#projectDetailsTab .plan-review-only-question');
        $(planReviewOnlyQuestion).removeClass('d-none');
        $(planReviewOnlyQuestion).find('.requiredField').removeClass('optionalField').addClass('requiredField');
    }

    function showInspectionCategoryTab() {
        $("#v-inspection-category-tab").removeClass("d-none");
    }

    function hideInspectionCategoryTab() {
        $("#v-inspection-category-tab").addClass("d-none");
    }

    function resetChanges() {
        deSelectBothService();
    }

    function isPlanReviewSelected() {
        return $("#plan_review_service").prop("checked");
    }

    function isInspectionSelected() {
        return $("#inspection_service").prop("checked");
    }

    function isBothSelected() {
        return isPlanReviewSelected() && isInspectionSelected();
    }

    function selectService(service) {
        $("#" + service).addClass("selected");
        window.selectedProjectType.push(service);
    }

    function deSelectService(service) {
        $("#" + service).removeClass("selected");

        // remove de-selected service from the window object
        const index = window.selectedProjectType.indexOf(service);
        if (index > -1) {
            window.selectedProjectType.splice(index, 1);
        }
    }

    function toggleNextStepButton() {
        if ($("#v-service-requested input:checkbox:checked").length > 0) {
            $('#v-service-requested .next-step-btn').attr('disabled', false);
        } else {
            $('#v-service-requested .next-step-btn').attr('disabled', true);
        }
    }
});
